export enum UploadStatus{
    UNKNOWN, 
    STAGED,
    UPLOADING,
    UPLOADED
}